import {
    ConnectedFormsIcon,
    SiteGlobeIcon,
    WebFormIcon,
    SearchIcon,
    ClipboardChecklistIcon,
    ChatIcon,
} from 'shells/icon';

type FeatureKey =
    | 'leadAttribution'
    | 'visitorIq'
    | 'trafficAnalysis'
    | 'nutshellForms'
    | 'connectedForms'
    | 'chat';

const LEAD_ATTRIBUTION_KEY = 'leadAttribution';
const VISITOR_IQ_KEY = 'visitorIq';
const TRAFFIC_ANALYSIS_KEY = 'trafficAnalysis';
const NUTSHELL_FORMS_KEY = 'nutshellForms';
const CONNECTED_FORMS_KEY = 'connectedForms';
const CHAT_KEY = 'chat';

export const FEATURE_CONFIG = {
    [LEAD_ATTRIBUTION_KEY]: {
        icon: ConnectedFormsIcon,
        title: 'Lead attribution',
        description: 'Learn where your best leads come from and what they do on your site',
        htmlPath: '/reports/attribution/details',
    },
    [VISITOR_IQ_KEY]: {
        icon: SearchIcon,
        title: 'VisitorIQ',
        description: 'Identify the companies that are visiting your site',
        htmlPath: '/marketing/visitors',
    },
    [TRAFFIC_ANALYSIS_KEY]: {
        icon: SiteGlobeIcon,
        title: 'Traffic analysis',
        description: 'See your traffic volume, sources, and conversion',
        htmlPath: '/marketing/analytics',
    },
    [NUTSHELL_FORMS_KEY]: {
        icon: ClipboardChecklistIcon,
        title: 'Nutshell forms',
        description: 'Embed forms to collect leads and schedule meetings',
        htmlPath: '/marketing/forms',
    },
    [CONNECTED_FORMS_KEY]: {
        icon: WebFormIcon,
        title: 'Connected forms',
        description: 'Collect leads from any form on your website',
        htmlPath: '/marketing/connected-forms',
    },
    [CHAT_KEY]: {
        icon: ChatIcon,
        title: 'Chat',
        description: 'Add live chat to interact with your visitors and generate more leads',
        htmlPath: '/inbox/settings/chat',
    },
} as const;

export function getTitle(key: FeatureKey) {
    return FEATURE_CONFIG[key].title;
}

export function getDescription(key: FeatureKey) {
    return FEATURE_CONFIG[key].description;
}

export function getIcon(key: FeatureKey) {
    return FEATURE_CONFIG[key].icon;
}

export function getHtmlPath(key: FeatureKey) {
    return FEATURE_CONFIG[key].htmlPath;
}

export type FeatureStatus = 'ACTIVE' | 'NOT_ACTIVE' | 'NOT_CONNECTED' | 'NOT_ENABLED';

const STATUS_ACTIVE = 'ACTIVE';
const STATUS_NOT_ACTIVE = 'NOT_ACTIVE';
const STATUS_NOT_CONNECTED = 'NOT_CONNECTED';
const STATUS_NOT_ENABLED = 'NOT_ENABLED';

export const STATUS_BADGE_TEXT_MAP = {
    [STATUS_ACTIVE]: {
        text: 'Active',
        level: 'success',
    },
    [STATUS_NOT_ACTIVE]: {
        text: 'Needs to be activated',
        level: 'warning',
    },
    [STATUS_NOT_CONNECTED]: {
        text: 'Not connected',
        level: 'info--grey',
    },
    [STATUS_NOT_ENABLED]: {
        text: 'Not enabled',
        level: 'warning',
    },
} as const;

export function getStatusBadge(status: FeatureStatus) {
    return STATUS_BADGE_TEXT_MAP[status];
}
